import api from './client.js'

export const lanEditionsAPI = {
  list:       () => api.get('/lan-editions'),
  getActive:  () => api.get('/lan-editions/active'),
  create:     (data) => api.post('/lan-editions', data),
  update:     (id, data) => api.patch(`/lan-editions/${id}`, data),
  delete:     (id) => api.delete(`/lan-editions/${id}`),
  activate:   (id) => api.post(`/lan-editions/${id}/activate`),
  archive:    (id) => api.get(`/lan-editions/${id}/archive`),
  populateTest: () => api.post('/lan-editions/populate-test'),
}
